import * as React from 'react';

function SvgPhotos(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 34.785 28.128" {...props}>
      <defs>
        <clipPath id="photos_svg__a">
          <path data-name="Rectangle 4088" fill="#eea804" d="M0 0h34.785v28.128H0z" />
        </clipPath>
      </defs>
      <g data-name="Group 5575">
        <path
          data-name="Path 4104"
          d="M2.193 8.4h7.068l1.869-6.215h12L25.406 8.4H32.6v17.535H2.193zM9.506 0L7.633 6.215H0v21.913h34.785V6.215h-7.852L24.653 0z"
          fill="#eea804"
        />
        <g data-name="Group 5574">
          <g data-name="Group 5573" clipPath="url(#photos_svg__a)" fill="#eea804">
            <path
              data-name="Path 4105"
              d="M17.392 6.407a8.753 8.753 0 108.753 8.753 8.762 8.762 0 00-8.753-8.753m0 15.318a6.565 6.565 0 116.565-6.565 6.573 6.573 0 01-6.565 6.565"
            />
            <path data-name="Rectangle 4087" d="M28.355 10.714h2.188v2.446h-2.188z" />
            <path
              data-name="Path 4106"
              d="M17.392 9.69v2.186a3.286 3.286 0 013.282 3.285h2.189a5.478 5.478 0 00-5.471-5.471"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPhotos;
